import React, { Suspense } from 'react';
import { CSSReset } from '@chakra-ui/react';

import Hero from '../Components/Home/Hero';
import Overview from '../Components/Home/Overview';
import VisionMission from '../Components/Home/VisionMission';
import ScrollToTopButton from '../Components/ScrollToTopButton';

const Services = React.lazy(() => import('../Components/Home/Services'));
const Projects = React.lazy(() => import('../Components/Home/Projects'));
const Partners = React.lazy(() => import('../Components/Home/Partners'));
const Contact = React.lazy(() => import('../Components/Home/Contact'));



const Home = () => {
  return (
    <>
      <CSSReset />

      <Hero />
      <Overview />
      <VisionMission />

      <Suspense fallback={null}>
        <Services />
        <Projects />
        <Partners />
        <Contact />
      </Suspense>

      <ScrollToTopButton />
    </>
  );
};

export default Home;